import { Body, Caption, VStatusIcon } from '@vrzl/ui';

import type { DocumentListItem } from '../api/types';
import { indexingStatusIcon, indexingStatusLabels } from '../constants';

import { DocumentTypeTag } from './documentTypeTag';
import { IndexingStatusTooltip } from './indexingStatusTooltip';

type DocumentSummaryProps = {
  document: DocumentListItem;
};

/**
 * De documentgegevens zoals ze in de documentenlijst staan: bestandstype-tag,
 * naam met extern nummer, en de AI-verwerkingsstatus met tooltip. Gedeeld tussen
 * de lijst en de documentdialog zodat beide hetzelfde tonen.
 */
export function DocumentSummary({ document }: DocumentSummaryProps) {
  return (
    <div className="flex min-w-0 flex-1 items-center gap-3">
      <DocumentTypeTag sourceFileName={document.sourceFileName} />
      <div className="min-w-0 flex-1">
        <Body weight="medium">{document.name}</Body>
        <Caption>{document.externalId}</Caption>
      </div>
      <IndexingStatusTooltip
        status={document.indexingStatus}
        errors={document.indexingErrors}
      >
        <VStatusIcon
          {...indexingStatusIcon[document.indexingStatus]}
          label={indexingStatusLabels[document.indexingStatus]}
        />
      </IndexingStatusTooltip>
    </div>
  );
}
